// Public signup page: prerendered for SEO + fast first paint.
// Overrides the SPA defaults in +layout.js (ssr=false, prerender=false).
export const ssr = true;
export const prerender = true;
